/**
 * How long until a notification should be dispatched(in seconds)
 */
const VIDEO_TRIGGER_TIME: number = 6;

export { VIDEO_TRIGGER_TIME };
